import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import Select from 'react-select';

export class GeneralLedgerSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            optionList: []
        }
    }

    componentDidMount() {
        var self = this;

        var storedData = localStorage.getItem('gl-' + this.props.accountId);
 
      
        if (storedData != null && storedData != 'undefined') {

            storedData = JSON.parse(storedData);
            var dateNow = new Date();
            var dateDiff = dateNow - Date.parse(storedData.date);
      
            if (Math.round(dateDiff / 60000) > 60) {
                localStorage.removeItem('gl-' + this.props.accountId);
                this.setData();
            } else {
                self.setState({ optionList: storedData.data });
            }            
        }
        else {
            this.setData();          
        }     
    }

    setData() {
        var self = this;
        /*alert('setData');*/
        fetch(`/api/general-ledger`)
            .then((response) => response.json())
            .then((json) => {
                localStorage.removeItem('gl-' + this.props.accountId);

                var storageData = {
                    date: new Date(),
                    data: json.list
                }

                localStorage.setItem('gl-' + this.props.accountId, JSON.stringify(storageData));

                self.setState({ optionList: json.list });
            });
    }

    render() {

        return (// Use the form field and your custom input together to create your very own input!
            <Field field={this.props.field} length={this.state.optionList.length}>
                {fieldApi => {

                    // Remember to pull off everything you dont want ending up on the <input>
                    // thats why we pull off onChange, onBlur, and field
                    // Note, the ...rest is important because it allows you to pass any
                    // additional fields to the internal <input>.
                    const { onChange, onBlur, field, ...rest } = this.props;

                    const { value, error, warning, success, setValue, setTouched } = fieldApi;

          

                    return (
                        <div>
                            <Select
                                {...rest}
                                name="form-field-name"
                                className="general-ledger-selector"
                                value={value}
                                filterOption={false}
                                options={this.state.optionList}
                                getOptionLabel={(option) => option.name + " - " + option.code}
                                getOptionValue={(option) => option.id}
                                onChange={value => {
                                    setValue(value);

                                    if (onChange) {
                                        onChange(value);
                                    }
                                }}
                                onBlur={ev => {
                                    setTouched();
                                    if (onBlur) {
                                        onBlur(ev);
                                    }
                                }} />
                        </div>
                    );
                }}
            </Field>);
    }
}